import { render, staticRenderFns } from "./task-create.vue?vue&type=template&id=de2d2202&"
import script from "./task-create.vue?vue&type=script&lang=ts&"
export * from "./task-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports